<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <svg-icon src="./assets/images/icons/close.svg"></svg-icon>
    </button>
</div>
<div class="modal-body text-center">
    <h4 class="font-weight-semibold mb-3 mb-md-4">QR Code({{vegname}})</h4>
    <img [src]="link" alt="" class="mb-3 mb-md-4" *ngIf="link != ''" style="width: 250px;">
    <p *ngIf="link == ''">No QR code found for this plant.</p>
    <span class="d-block w-75 mx-auto border-bottom border-light mb-2 mb-md-3"></span>
    <p class="small font-weight-semibold mb-0" *ngIf="link != ''">Downloaded Successfully</p>
</div>